module.exports = __webpack_public_path__ + "img/dangerous-breeds-en.56ba1083.svg";